import './BasicFooter.scss'

import { useNavigate } from '@reach/router'
import React, { useCallback } from 'react'

import { useFeatureContext } from '../../contexts/feature'
import { ROUTES } from '../../pages/routes'
import {
  showAboutUsPage,
  showAntiHumanTrafickingPage,
  showContactPage,
  showFAQPage,
  showNonConsensualParticipationPage,
  showPricingPage,
  showPrivacyPolicyPage,
  showTermsAndConditionPage,
} from '../../services/navigation-service/navigation.service'
import LogoComponent from '../LogoComponent/LogoComponent'
import StaticPagesList from '../StaticPages/StaticPagesList'

const BasicFooter = () => {
  const navigate = useNavigate()
  const { feature_static_pages } = useFeatureContext()
  const onNavigateToSlug = useCallback(
    slug => {
      navigate(`${ROUTES.STATIC}/${slug}`)
    },
    [navigate],
  )
  return (
    <div className="BasicFooter">
      <div className="BasicFooter-Container Container">
        <div className="BasicFooter-Content">
          <div className="Links-Column">
            <div className="ListName">Quick Links</div>
            <p onClick={showAboutUsPage}>About Us</p>
            <p onClick={showFAQPage}>FAQs</p>
            <p onClick={showPricingPage}>Pricing</p>
            <p onClick={showContactPage}>Contact Us</p>
          </div>
          <div className="FooterLogo-Content phoneLogoContent">
            <LogoComponent />
            <p>
              LocalFlirt is a discreet and satisfying place to live out your
              wildest desires! Flirt and chat with like-minded adults online now
            </p>
          </div>
          <div className="Corporation-Column">
            <div className="ListName">Corporation</div>
            <p>Gochamie Inc</p>
            <p>20 North Orange Avenue Suite 1100 11th Floor</p>
            <p>Orlando, FL 32801</p>
            <p>877-381-0324</p>
          </div>
        </div>
      </div>
      <div className="CopyrightFooter">
        <div className="CopyrightFooter-Container Container">
          <div className="Copyright-Text">
            Copyright © {new Date().getFullYear()} LocalFlirt. All Rights
            Reserved.
          </div>
          {feature_static_pages ? (
            <StaticPagesList
              className={'Terms-Container'}
              linkClassName={'Copyright-Text'}
              separatorClassName={'Text_Line_Separator'}
              onNavigateToSlug={onNavigateToSlug}
            >
              <span className="Text_Line_Separator">|</span>{' '}
              <span className="Copyright-Text" onClick={showContactPage}>
                Support
              </span>
            </StaticPagesList>
          ) : (
            <div className="Terms-Container">
              <span
                className="Copyright-Text"
                onClick={showTermsAndConditionPage}
              >
                Terms and Conditions
              </span>{' '}
              <span className="Text_Line_Separator">|</span>{' '}
              <span className="Copyright-Text" onClick={showPrivacyPolicyPage}>
                Privacy Policy
              </span>{' '}
              <span className="Text_Line_Separator">|</span>{' '}
              <span
                className="Copyright-Text"
                onClick={showAntiHumanTrafickingPage}
              >
                Anti-Human Trafficking Policy
              </span>{' '}
              <span className="Text_Line_Separator">|</span>{' '}
              <span
                className="Copyright-Text"
                onClick={showNonConsensualParticipationPage}
              >
                Non-Consensual Participation Policy
              </span>{' '}
              <span className="Text_Line_Separator">|</span>{' '}
              <span className="Copyright-Text" onClick={showContactPage}>
                Support
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default BasicFooter
